// extracted by mini-css-extract-plugin
export var standaloneTable = "_j0-0";
export var standaloneTableWithBodyFill = "_j0-1";
export var withExtraHeader = "_j0-2";